













import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Kompetenzen extends Vue {
  // data
  private kompetenzen = [
    {
      name: 'Gebäudereinigung',
      path: 'gebaeudereinigung',
      img: ''
    },
    {
      name: 'Industriereinigung',
      path: 'industriereinigung',
      img: ''
    },
    {
      name: 'Gebäudemanagement',
      path: 'gebaeudemanagement',
      img: ''
    },
    {
      name: 'Winterdienst',
      path: 'winterdienst',
      img: ''
    },
    {
      name: 'Hausmeisterservice',
      path: 'hausmeisterdienst',
      img: ''
    },
    {
      name: 'Gartenpflege',
      path: 'garten',
      img: ''
    }
  ]
}
